// IMPORT BASE-MODULE
import BaseModule from '@core/modules/base-module/base-module';
import $ from "jquery";

// IMPORT COMPONENTS
import moduleBackgroundImage from "@core/components/module-background-image/module-background-image";
import Pattern from '@pj/components/pattern/pattern';
import ThemesNavigation from '@pj/components/themes-navigation/themes-navigation';

let themesNav=null;
const bannerArticle=new BaseModule();
bannerArticle.name='banner-home';
bannerArticle.init(that=> {
  moduleBackgroundImage(that.elements);

  themesNav=new ThemesNavigation();
  themesNav.init(that.elements);

  const pattern=new Pattern();
  pattern.init(that.elements);
});

bannerArticle.onResize(()=>{
  if(themesNav){
    themesNav.onResize();
  }
})

